import React, { useEffect, useState } from 'react';
import "./dashboard.css";
import axios from 'axios';



// const API_URL = "http://localhost:8000/student.php";
const API_URL = "https://crm.fazoacademy.in/php/student.php";

// const API_URL_COURSE = "http://localhost:8000/course.php";
const API_URL_COURSE = "https://crm.fazoacademy.in/php/course.php";

// const API_URL_ENQUIRY = "http://localhost:8000/enquiry.php";
const API_URL_ENQUIRY = "https://crm.fazoacademy.in/php/enquiry.php";





const Dashboard = ({onLogout}) => {
  const [dashboard, setDashboard] = useState([]);
  const [course, setCourse] = useState([]);
  const [enquiry, setEnquiry] = useState([]);

  const fetchDashboard = async () => {
    try {
      const response = await axios.get(API_URL);
      console.log("Raw API Response:", response.data);
      const jsonString = response.data.substring(response.data.indexOf("["));
      const parsedData = JSON.parse(jsonString);
      setDashboard(Array.isArray(parsedData) ? parsedData : []);
    } catch (error) {
      console.error("Error fetching courses:", error);
      setDashboard([]);
    }
  };

  const fetchCourses = async () => {
    try {
      const response = await axios.get(API_URL_COURSE);
      console.log("Raw API Response:", response.data);
      const jsonString = response.data.substring(response.data.indexOf("["));
      const parsedData = JSON.parse(jsonString);
      setCourse(Array.isArray(parsedData) ? parsedData : []);
      console.log(course);
    } catch (error) {
      console.error("Error fetching courses:", error);
      setCourse([]);
    }
  };
  
  const fetchEnquiry = async () => {
    try {
      const response = await axios.get(API_URL_ENQUIRY);
      console.log("Raw API Response:", response.data);
      const jsonString = response.data.substring(response.data.indexOf("["));
      const parsedData = JSON.parse(jsonString);
      setEnquiry(Array.isArray(parsedData) ? parsedData : []);
      // console.log(course);
    } catch (error) {
      console.error("Error fetching courses:", error);
      setEnquiry([]);
    }
  };

  const studentCount = dashboard.filter(student => student.name && student.status === "Active").length;

  const Coursecompleted = dashboard.filter(student => student.coursecompleted === "Yes").length;
  const Discontinuedstudent = dashboard.filter(student => student.Discontinued === "Yes").length;
  const Paymentmode = dashboard.filter(student => student.paymentmode === "EMI").length;
  const Paymentmode1 = dashboard.filter(student => student.paymentmode === "NetCash").length;
  const Certificate = dashboard.filter(student => student.certificate === "Received").length;
  const paymentstatus = dashboard.filter(student => student.paymentstatus === "Paid").length;
  const paymentstatus1 = dashboard.filter(student => student.paymentstatus !== "Paid").length;

  const coursecount = course.filter(course => course.name).length;

  const Enquirycount = enquiry.filter(enquiry => enquiry.name).length;


  useEffect(() => {
    fetchCourses();
    fetchDashboard();
    fetchEnquiry();
  }, []);
  return (
    <>
    <div>
      <div className="navigation">
        <a href="#">Dashboard</a> / <a href="#"      onClick={onLogout}>Logout</a>
      </div>
<br></br>
      <div id="root">

        <div class="container pt-3">
          <div class="row align-items-stretch">
            <div class="c-dashboardInfo col-lg-2 col-md-6">
              <div class="wrap">
                <h4 class="heading heading5 hind-font medium-font-weight c-dashboardInfo__title">Total Student<svg
                  class="MuiSvgIcon-root-19" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z">
                  </path>
                </svg></h4><span class="hind-font caption-12 c-dashboardInfo__count">{studentCount}</span>
              </div>

            </div>
            <div class="c-dashboardInfo col-lg-2 col-md-6">
              <div class="wrap">
                <h4 class="heading heading5 hind-font medium-font-weight c-dashboardInfo__title">Course Completed Student<svg
                  class="MuiSvgIcon-root-19" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z">
                  </path>
                </svg></h4><span class="hind-font caption-12 c-dashboardInfo__count">{Coursecompleted}</span>
              </div>
            </div>
            <div class="c-dashboardInfo col-lg-2 col-md-6">
              <div class="wrap">
                <h4 class="heading heading5 hind-font medium-font-weight c-dashboardInfo__title">Discontinued Student<svg
                  class="MuiSvgIcon-root-19" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z">
                  </path>
                </svg></h4><span class="hind-font caption-12 c-dashboardInfo__count">{Discontinuedstudent}</span>
              </div>
            </div>
            <div class="c-dashboardInfo col-lg-2 col-md-6">
              <div class="wrap">
                <h4 class="heading heading5 hind-font medium-font-weight c-dashboardInfo__title">Certificate Issued<svg
                  class="MuiSvgIcon-root-19" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z">
                  </path>
                </svg></h4><span class="hind-font caption-12 c-dashboardInfo__count">{Certificate}</span>
              </div>
            </div>
            <div class="c-dashboardInfo col-lg-2 col-md-6">
              <div class="wrap">
                <h4 class="heading heading5 hind-font medium-font-weight c-dashboardInfo__title">Certificate Issued<svg
                  class="MuiSvgIcon-root-19" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z">
                  </path>
                </svg></h4><span class="hind-font caption-12 c-dashboardInfo__count">{Certificate}</span>
              </div>
            </div>
            <div class="c-dashboardInfo col-lg-2 col-md-6">
              <div class="wrap">
                <h4 class="heading heading5 hind-font medium-font-weight c-dashboardInfo__title">EMI Payment<svg
                  class="MuiSvgIcon-root-19" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z">
                  </path>
                </svg></h4><span class="hind-font caption-12 c-dashboardInfo__count">{Paymentmode}</span>
              </div>

            </div>

          </div>
        </div>
        <div class="container pt-3">
          <div class="row align-items-stretch">
            <div class="c-dashboardInfo col-lg-2 col-md-6">
              <div class="wrap">
                <h4 class="heading heading5 hind-font medium-font-weight c-dashboardInfo__title">Total Student<svg
                  class="MuiSvgIcon-root-19" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z">
                  </path>
                </svg></h4><span class="hind-font caption-12 c-dashboardInfo__count">{studentCount}</span>
              </div>

            </div>
            <div class="c-dashboardInfo col-lg-2 col-md-6">
              <div class="wrap">
                <h4 class="heading heading5 hind-font medium-font-weight c-dashboardInfo__title">Course Completed Student<svg
                  class="MuiSvgIcon-root-19" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z">
                  </path>
                </svg></h4><span class="hind-font caption-12 c-dashboardInfo__count">{Coursecompleted}</span>
              </div>
            </div>
            <div class="c-dashboardInfo col-lg-2 col-md-6">
              <div class="wrap">
                <h4 class="heading heading5 hind-font medium-font-weight c-dashboardInfo__title">Discontinued Student<svg
                  class="MuiSvgIcon-root-19" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z">
                  </path>
                </svg></h4><span class="hind-font caption-12 c-dashboardInfo__count">{Discontinuedstudent}</span>
              </div>
            </div>
            <div class="c-dashboardInfo col-lg-2 col-md-6">
              <div class="wrap">
                <h4 class="heading heading5 hind-font medium-font-weight c-dashboardInfo__title">Certificate Issued<svg
                  class="MuiSvgIcon-root-19" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z">
                  </path>
                </svg></h4><span class="hind-font caption-12 c-dashboardInfo__count">{Certificate}</span>
              </div>
            </div>
            <div class="c-dashboardInfo col-lg-2 col-md-6">
              <div class="wrap">
                <h4 class="heading heading5 hind-font medium-font-weight c-dashboardInfo__title">Enquiry Count<svg
                  class="MuiSvgIcon-root-19" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z">
                  </path>
                </svg></h4><span class="hind-font caption-12 c-dashboardInfo__count">{Enquirycount}</span>
              </div>
            </div>
            <div class="c-dashboardInfo col-lg-2 col-md-6">
              <div class="wrap">
                <h4 class="heading heading5 hind-font medium-font-weight c-dashboardInfo__title">Course Count<svg
                  class="MuiSvgIcon-root-19" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z">
                  </path>
                </svg></h4><span class="hind-font caption-12 c-dashboardInfo__count">{coursecount}</span>
              </div>

            </div>

          </div>
        </div>

      </div>

      </div>
   
</>

  );
};

export default Dashboard;
